"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackMROAuthClosed = trackMROAuthClosed;
exports.trackMROAuthShown = trackMROAuthShown;
var _analytics = require("@cian/analytics");
function trackMROAuthShown() {
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: 'MailruAuthBlock',
    action: 'show'
  });
}
function trackMROAuthClosed() {
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: 'MailruAuthBlock',
    action: 'close'
  });
}